(function () {
	'use strict';

    angular.module("imApp").factory("poService", ['$ihttp', function ($ihttp) {
		let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1352,
                    parameters: parms || {}
                });
            },
            listPoStatuses: function (parms) {
                return $ihttp.post({
					method: 2002,
                    parameters: parms || {}
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 1926,
                    parameters: edit
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
					method: 2444,
                    parameters: edit
                });
            }
		};

		return service;
	}]);
})();
